module.exports = __webpack_public_path__ + "img/reaction17.3a6ea6f4.png";